import { render, staticRenderFns } from "./t-app-menu-right-button-mobile.vue?vue&type=template&id=0ca866b8&scoped=true&"
import script from "./t-app-menu-right-button-mobile.vue?vue&type=script&lang=js&"
export * from "./t-app-menu-right-button-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca866b8",
  null
  
)

export default component.exports